import Grid from '@mui/material/Grid';
import { observer } from 'mobx-react-lite';
import { PromiseContainer, Title } from '../../../../../components';
import { useStore } from '../../../../../store';
import { PulseKeyStatusOptions } from '../../../../../store/constants/pulseKeys';
import usePromise from '../../../../../store/utils/usePromise';
import { ProductStats } from '../../../store/Product';
import classes from './KeyStatsPanel.module.scss';

export default observer(function KeyStatsPanel({
  productId,
}: {
  productId: string;
}) {
  const { pulseKeyStore } = useStore();
  const [statPromise] = usePromise(() =>
    pulseKeyStore.fetchProductStats(productId),
  );

  return (
    <PromiseContainer empty={false} promise={statPromise}>
      {(stats) => <Component stats={stats} />}
    </PromiseContainer>
  );
});

const Component = observer(function Component({
  stats,
}: {
  stats: ProductStats;
}) {
  const statuses = stats.statuses
    .map((s) => extendStatus(s))
    .toSorted((a, b) => a.index - b.index);

  return (
    <Grid container spacing={4}>
      <Grid item xs={4}>
        <Title variant="h3">General</Title>
        <div className={classes.list}>
          <KeyValue name="All Keys" value={stats.total} />
          {stats.forWebhooks !== undefined && (
            <KeyValue name="For Webhooks" value={stats.forWebhooks} />
          )}
        </div>
      </Grid>
      <Grid item xs={4}>
        <Title variant="h3">Count by status</Title>
        <div className={classes.list}>
          {statuses.map(({ count, status, title }) => (
            <KeyValue key={status} name={title} value={count} />
          ))}
        </div>
      </Grid>
      <Grid item xs={4}>
        <Title variant="h3">Count by label</Title>
        <div className={classes.list}>
          {stats.labels.map(({ label, count }) => (
            <KeyValue key={label} name={label} value={count} />
          ))}
        </div>
      </Grid>
    </Grid>
  );
});

function KeyValue({ name, value }: { name: string; value: number | string }) {
  return (
    <dl className={classes.keyValue}>
      <dt>{name}</dt>
      <dd>{value}</dd>
    </dl>
  );
}

function extendStatus(status: { count: number; status: string }): {
  count: number;
  index: number;
  status: string;
  title: string;
} {
  const index = PulseKeyStatusOptions.findIndex(
    ({ value }) => value === status.status,
  );
  return {
    ...status,
    index,
    title: PulseKeyStatusOptions[index]?.label || status.status,
  };
}
